export const updateTaskBlueprintAnswerAction = payload => (
  dispatch => dispatch({
    type:     UPDATE_TASK_BLUEPRINT_ANSWER.ACTION,
    payload:  payload
  })
)

export const UPDATE_TASK_BLUEPRINT_ANSWER = {
  ACTION: 'UPDATE_TASK_BLUEPRINT_ANSWER',

  call: ({ state, workorderId, taskId, blueprintAnswer }) => ({
    ...state,
    items: state.items.map(workorder => workorder.id != workorderId ? workorder : {
      ...workorder,
      synced: false,
      maintenance_tasks: workorder.maintenance_tasks.map(task => task.id != taskId ? task : {
        ...task,
        blueprint_answer: { ...blueprintAnswer, dirty: false, updated: true }
      })
    })
  })
}
